//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import {
  INFLUENCER_SEARCH_LIMITS,
  INFLUENCERS_SEARCH_ACTIONS,
} from '@influencers/constants/influencersConstants';
import { IInfluencerSearch } from '@influencers/models/influencersStateModel';
import { InfluencersSearchActionsType } from '../actions/influencersSearchActions';

const initialState: IInfluencerSearch = {
  searchInput: '',
  searchTerms: [],
  searchCount: undefined,
  searchResults: undefined,
  suggestedInfluencers: [],
  flags: {
    requestingSearchResultsId: undefined,
    isRequestingFindResults: false,
    isRequestingSuggestedInfluencers: false,
    hasNoMoreSuggestions: false,
    hasIgInsightsFeature: undefined,
  }
};

export default function EmailBuilderCustomizationReducer(
  state: IInfluencerSearch = initialState,
  action: InfluencersSearchActionsType,
): IInfluencerSearch {
  switch (action.type) {
    case INFLUENCERS_SEARCH_ACTIONS.SEARCH_INFLUENCERS_REQUESTED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingFindResults: true,
        }
      };
    }
    case INFLUENCERS_SEARCH_ACTIONS.SEARCH_INFLUENCERS_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingFindResults: false,
        },
        searchCount: action.count,
        searchResults: action.users
      };
    }
    case INFLUENCERS_SEARCH_ACTIONS.SEARCH_INFLUENCERS_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingFindResults: false,
        }
      };
    }
    case INFLUENCERS_SEARCH_ACTIONS.SUGGESTED_INFLUENCERS_REQUESTED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingSuggestedInfluencers: true,
        }
      };
    }
    case INFLUENCERS_SEARCH_ACTIONS.SUGGESTED_INFLUENCERS_SUCCEEDED: {
      return {
        ...state,
        suggestedInfluencers: [
          ...state.suggestedInfluencers,
          ...action.users
        ],
        flags: {
          ...state.flags,
          isRequestingSuggestedInfluencers: false,
          hasNoMoreSuggestions: action.users.length === 0
        }
      };
    }
    case INFLUENCERS_SEARCH_ACTIONS.SUGGESTED_INFLUENCERS_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isRequestingSuggestedInfluencers: false,
        }
      };
    }
    case INFLUENCERS_SEARCH_ACTIONS.CLEAR_SEARCH: {
      return {
        ...state,
        searchInput: initialState.searchInput,
        searchTerms: initialState.searchTerms,
        searchCount: initialState.searchCount,
        searchResults: initialState.searchResults,
      };
    }
    case INFLUENCERS_SEARCH_ACTIONS.CLEAR_SUGGESTED_INFLUENCERS: {
      return {
        ...state,
        suggestedInfluencers: initialState.suggestedInfluencers,
        flags: {
          ...state.flags,
          hasIgInsightsFeature: undefined,
        }
      };
    }
    case INFLUENCERS_SEARCH_ACTIONS.UPDATE_SEARCH_INPUT: {
      return {
        ...state,
        searchInput: action.searchInput,
      };
    }
    case INFLUENCERS_SEARCH_ACTIONS.UPDATE_INSTAGRAM_STATUS: {
      return {
        ...state,
        flags: {
          ...state.flags,
          hasIgInsightsFeature: action.isConnected,
        },
      };
    }
    default:
      return state;
  }
}
